<template>
  <div id="feature-controller">
    <div v-if="error" class="response-handler">
      <Error />
    </div>
    <div v-if="loader" class="response-handler">
      <Loader />
    </div>
    <div :class="[i !== items.length - 1 ? 'card-border-bottom' : '', 'card-container']" v-for="(item, i) in items" :key="i">
      <service-and-feature-controller-card type="features"  :data="item"/>
    </div>
  </div>
</template>
<script>
import ServiceAndFeatureControllerCard from '../../../components/cards/ServiceAndFeatureControllerCard'
import FeatureControllerRepository from '../../../repositories/FeatureControllerRepository'
import Loader from '../../../components/LoaderBtn/Loader'
import Error from '../../../components/errorHandle/Error'
export default {
  components: { ServiceAndFeatureControllerCard, Loader, Error },
  data () {
    return {
      lang: this.$lang,
      featureRepo: new FeatureControllerRepository(),
      items: [],
      loader: false,
      error: false,
      gsm: this.$store.state.selectedNumber
    }
  },
  created () {
    this.fetchData(this.gsm)
    this.$watch(() => {
      return this.$store.state.passedNum
    }, val => {
      this.items = []
      this.error = false
      this.loader = false
      this.fetchData(val)
    })
  },
  methods: {
    async fetchData (gsm) {
      const formData = new FormData()
      formData.append('gsm', gsm)
      this.loader = true
      try {
        const response = await this.featureRepo.post(formData)
        let hotLineItem = {}
        if (response.status === 200) {
          for (let i = 0; i < response.data.data.length; i++) {
            if (response.data.data[i].type === 2) {
              hotLineItem = { ...response.data.data[i] }
              this.items.push(response.data.data[i])
              this.items[i].active = false
            } else {
              this.items.push(response.data.data[i])
            }
          }
          // Add an item to the controllers array to enable deactivating hotline (the title is static & the description is the same of hotline item from back)
          hotLineItem.active = true
          hotLineItem.title = this.$t('feature.activateNum')
          this.items.push(hotLineItem)
          this.error = false
          this.load = false
        } else {
          this.error = true
        }
        // console.log(response)
      } catch (e) {
        this.error = true
      }
      this.loader = false
    }
  }
}
</script>
<style lang="scss" scoped>
#feature-controller {
  padding: 1rem;
  height: calc(100vh - (90px + 110px));
  overflow-y: auto;
}
.response-handler{
  height: calc(100vh - (110px + 90px))
}
.card-container {
  padding: 0.5rem 0 0.5rem 0;
}
.card-border-bottom{
  border-bottom: 2px solid rgba(0,0,0,.15);
}
@media (max-width: 1200px) {
  #feature-controller {
    overflow-y: unset;
  }
}
</style>
